package com.partejar.app.feature.relacionamentos.presentation

import androidx.compose.ui.graphics.vector.ImageVector
import com.partejar.app.core.ui.components.PartejarStatusBadgeTone
import com.partejar.app.core.ui.theme.PartejarIcons
import com.partejar.app.feature.relacionamentos.data.InteractionKind
import com.partejar.app.feature.relacionamentos.data.RelacionamentoStage

internal data class RelationshipStagePresentation(
    val label: String,
    val icon: ImageVector,
    val tone: PartejarStatusBadgeTone
)

internal fun stagePresentation(stage: RelacionamentoStage): RelationshipStagePresentation = when (stage) {
    RelacionamentoStage.CAPTURE -> RelationshipStagePresentation(
        label = "Captação",
        icon = PartejarIcons.Relationships.capture,
        tone = PartejarStatusBadgeTone.NEUTRAL
    )
    RelacionamentoStage.MEETING -> RelationshipStagePresentation(
        label = "Reunião",
        icon = PartejarIcons.Relationships.meeting,
        tone = PartejarStatusBadgeTone.INFO
    )
    RelacionamentoStage.WAITING -> RelationshipStagePresentation(
        label = "Aguardando fechamento",
        icon = PartejarIcons.Relationships.waiting,
        tone = PartejarStatusBadgeTone.ACCENT
    )
    RelacionamentoStage.CONTRACT -> RelationshipStagePresentation(
        label = "Contrato",
        icon = PartejarIcons.Relationships.contract,
        tone = PartejarStatusBadgeTone.PRIMARY
    )
    RelacionamentoStage.LOST -> RelationshipStagePresentation(
        label = "Perdido",
        icon = PartejarIcons.Relationships.lost,
        tone = PartejarStatusBadgeTone.NEUTRAL
    )
}

internal data class InteractionPresentation(
    val label: String,
    val icon: ImageVector
)

internal fun interactionPresentation(kind: InteractionKind): InteractionPresentation = when (kind) {
    InteractionKind.CONTACT -> InteractionPresentation("Primeiro contato", PartejarIcons.Relationships.contact)
    InteractionKind.MEETING -> InteractionPresentation("Reunião", PartejarIcons.Relationships.meeting)
    InteractionKind.FOLLOW_UP -> InteractionPresentation("Retorno", PartejarIcons.Relationships.followUp)
    InteractionKind.WHATSAPP -> InteractionPresentation("WhatsApp", PartejarIcons.Relationships.whatsApp)
    InteractionKind.INSTAGRAM -> InteractionPresentation("Instagram", PartejarIcons.Relationships.instagram)
    InteractionKind.OTHER -> InteractionPresentation("Outro", PartejarIcons.Relationships.other)
}

internal fun stageLabel(stage: RelacionamentoStage): String = stagePresentation(stage).label

internal fun relationshipOriginLabel(origin: String?): String = when (origin) {
    "WHATSAPP" -> "WhatsApp"
    "INSTAGRAM" -> "Instagram"
    "INDICACAO" -> "Indicação"
    "OUTRO" -> "Outro"
    null -> "Não informada"
    else -> origin
}
